import { ApiType } from 'utils/types'

// Candidate wire drafts: collections/sections exist even when no answer has been saved.
export const willDraft: ApiType['UserDirectiveWillResponse'] = {
  uuid: '69060000-0000-4000-8000-000000000001',
  owner_uuid: '69060000-0000-4000-8000-000000000002',
  state: 'IN_DRAFT',
  user_detail: null,
  marital_status: null,
  partner: null,
  children: { items: [] },
  children_under_age: false,
  guardians: { items: [] },
  pets: { items: [] },
  surrender_pet_type: null,
  surrender_pet_place: null,
  surrender_pet_person: null,
  executors: { items: [] },
  digital_executor: null,
  digital_executor_access: false,
  properties: { items: [] },
  real_estates: { items: [] },
  stocks: { items: [] },
  donations: { items: [] },
  insurances: { items: [] },
  beneficiary_survive_days: null,
  beneficiaries: { items: [] },
  beneficiary_death_type: null,
  alternate_beneficiaries: { items: [] },
  charity_beneficiaries: { items: [] },
  substitute_beneficiary_rules: [],
  second_substitute_beneficiary_rules: [],
  witnesses: { items: [] },
  has_witnesses: null,
  section_state: { visited_sections: [] },
  people: [],
  validation_errors: [],
  eligible_download: false,
  upsell_modal: false,
}

export const trustDraft: ApiType['UserDirectiveTrustResponse'] = {
  uuid: '69060000-0000-4000-8000-000000000001',
  owner_uuid: '69060000-0000-4000-8000-000000000002',
  state: 'IN_DRAFT',
  user_detail: null,
  family: {
    marital_status: null,
    partner: null,
    joint_trust: false,
    children: { items: [] },
    children_under_age: false,
    guardians: { items: [] },
    pets: { items: [] },
  },
  trust: {
    formatted_trust_name: 'Candidate Trust',
    trustee_someone_else: false,
    cotrustee_someone_else: false,
    has_cotrustee: false,
    trustee: { person: { person: {}, address: {} } },
    cotrustee: {},
    successor_trustee: {},
    successor_cotrustee: {},
  },
  distribution_of_property: {
    assets: [],
    specific_distributions: false,
    trustees_manage_accounts: true,
    receival_age: null,
    digital_executor: null,
  },
  remaining_estate: {
    beneficiaries: { items: [] },
    alternate_beneficiaries: { items: [] },
    charity_beneficiaries: { items: [] },
  },
  pour_over_will: {
    pour_over: false,
    successor_trustee_is_executor: false,
    spouse1_uses_spouse2_as_executor: false,
    spouse2_uses_spouse1_as_executor: false,
  },
  section_state: { visited_sections: [] },
  people: [],
  validation_errors: [],
  eligible_download: false,
}
